import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone } from 'lucide-react';
import { companyInfo, serviceAreas } from '../mock';

const ServiceAreas = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="pt-32 pb-16" style={{ background: 'var(--bg-section)' }}>
        <div className="container text-center">
          <h1 className="heading-1 mb-6">Service Areas</h1>
          <p className="body-large max-w-3xl mx-auto" style={{ color: 'var(--text-secondary)' }}>
            Serving New York City, Long Island, and Westchester County with professional pest control services
          </p>
        </div>
      </section>

      {/* Service Areas Grid */}
      <section className="py-20">
        <div className="container">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {serviceAreas.map(area => (
              <Link
                key={area.id}
                to={`/areas/${area.id}`}
                className="product-card card-hover-lift text-center"
              >
                <div className="w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center" style={{ background: 'var(--accent-wash)' }}>
                  <MapPin size={32} style={{ color: 'var(--accent-text)' }} />
                </div>
                <h3 className="heading-3 mb-2">{area.name}</h3>
                <p className="body-small mb-4" style={{ color: 'var(--text-secondary)' }}>
                  {area.description}
                </p>
                <div className="flex items-center justify-center gap-2" style={{ color: 'var(--accent-text)' }}>
                  <span className="body-small font-semibold">View Details →</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Coverage Section */}
      <section className="py-20" style={{ background: 'var(--bg-section)' }}>
        <div className="container">
          <div className="text-center mb-12">
            <h2 className="heading-2 mb-4">Complete New York Coverage</h2>
            <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
              Professional pest control wherever you are
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <h3 className="heading-3 mb-4">NYC Boroughs</h3>
              <ul className="space-y-2">
                <li className="body-medium">• Manhattan</li>
                <li className="body-medium">• Brooklyn</li>
                <li className="body-medium">• Queens</li>
                <li className="body-medium">• The Bronx</li>
                <li className="body-medium">• Staten Island</li>
              </ul>
            </div>
            
            <div>
              <h3 className="heading-3 mb-4">Long Island</h3>
              <ul className="space-y-2">
                <li className="body-medium">• Nassau County</li>
                <li className="body-medium">• Suffolk County</li>
              </ul>
            </div>
            
            <div>
              <h3 className="heading-3 mb-4">Surrounding Areas</h3>
              <ul className="space-y-2">
                <li className="body-medium">• Westchester County</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20">
        <div className="container text-center">
          <h2 className="heading-2 mb-4">Don't See Your Area?</h2>
          <p className="body-large mb-8" style={{ color: 'var(--text-secondary)' }}>
            Contact us to check if we serve your location
          </p>
          <a href={`tel:${companyInfo.phoneRaw}`} className="btn-primary text-lg px-8">
            <Phone size={20} />
            Call {companyInfo.phone}
          </a>
        </div>
      </section>
    </div>
  );
};

export default ServiceAreas;